import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { IQuestionnaire } from 'src/app/modules/shared/models/operation.model';

@Component({
  selector: 'app-questionnaire-modal',
  templateUrl: './questionnaire-modal.component.html',
  styleUrl: './questionnaire-modal.component.scss'
})
export class QuestionnaireModalComponent implements OnInit, OnDestroy {

  destroy$ = new Subject<void>;
  onViewSubject!: (key: IFormKey) => void;
  onDeleteSubject!: (key: IFormKey) => void;
  onNewLiquidationSubjectsChange!: (subjects: Record<string, { rawFormOutcome: Record<string, any>; mappedOutcome: Record<string, any> }>) => void;

  constructor(
    public dialogRef: MatDialogRef<QuestionnaireModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData
  ) { }

  ngOnInit(): void {
    if (this.isReadOnly && this.questionnaireForm) {
      this.questionnaireForm.disable();
    }
    this.onViewSubject = this.modalData.onViewSubject;
    this.onDeleteSubject = this.modalData.onDeleteSubject;
    this.onNewLiquidationSubjectsChange = this.modalData.onNewLiquidationSubjectsChange;
  }

  close(updateQuestionnairesArray: boolean) {
    !updateQuestionnairesArray ?
      this.dialogRef.close() :
      this.dialogRef.close({
        questionnaireForm: this.questionnaireForm,
        fiscalCode: this.fiscalCode
      });
  }

  get questionnaireForm(): FormGroup {
    return (this.modalData && this.modalData.questionnaireForm) || null;
  }

  get formKeys(): IFormKey[] {
    return (this.modalData && this.modalData.formKeys) || [];
  }

  get questionnaire(): IQuestionnaire {
    return (this.modalData && this.modalData.questionnaire) || null;
  }

  get fiscalCode(): string {
    return (this.modalData && this.modalData.fiscalCode) || null;
  }

  get isReadOnly(): boolean {
    return (this.modalData && this.modalData.isReadOnly) || null;
  }

  get newLiquidationSubjects(): Record<string, { rawFormOutcome: Record<string, any>; mappedOutcome: Record<string, any> }> {
    return (this.modalData && this.modalData.newLiquidationSubjects) || {};
  }

  get isQuestionnaireFormValid(): boolean {
    const keys = this.formKeys.filter(x => !x.hidden);
    const isAnyControlInvalid = keys.some(key => {
      const control = this.questionnaireForm.get(key?.controlName);
      return control ? control.invalid : false;
    })
    return !isAnyControlInvalid;
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
